<template>
  <div :class="['compose', floor.$style]" :style="{ height: swiperHeight }">
    <div class="div">
      <c-swiper
        class="swiper"
        :tag="tag"
        :autoplay="5000"
        :show-indicators="false"
        @change="(i) => (swiperIndex = i)"
      >
        <img
          class="image"
          v-for="(item, index) of items"
          :key="index"
          :src="item.pageImgUrl"
          alt=""
          @click="onLeftClick(item, index)"
        />
      </c-swiper>
      <div class="indicators" v-if="items.length > 1">
        <i
          :class="['indicator', swiperIndex === index ? 'active' : '']"
          v-for="(item, index) of items"
          :key="index"
        ></i>
      </div>
    </div>
    <div class="div">
      <div class="view" v-for="(list, index) of items2" :key="index">
        <div class="image-box" v-for="(item, idx) of list" :key="idx">
          <img
            class="image"
            :src="item.pageImgUrl"
            alt=""
            @click="onRightClick(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CSwiper from '@/views/activities/components/c-swiper';
import { navigateTo } from '@/views/activities/utils';
import utils from '@/utils/common';
export default {
  components: { CSwiper },
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      swiperHeight: '0',
      swiperIndex: 0,
      items: [],
      items2: []
    };
  },
  watch: {
    floor: {
      immediate: true,
      handler: 'init'
    }
  },
  computed: {
    tag() {
      return this.items.length <= 1 ? 'div' : 'swiper';
    }
  },
  methods: {
    /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init)
     * 包裹代码保证每次执行只触发一次
     */
    init() {
      const { floor } = this;
      const scale = 543 / 750; // 543为原型设计稿图无边距时高度
      this.swiperHeight = utils.rem2px(scale * floor.$viewWidth);
      floor.items2.forEach((item, i) => (item.$i = i));
      this.items = floor.items;
      this.items2 = this.chunkArray(floor.items2, 2);
    },
    chunkArray(arr, size) {
      const res = [];
      for (let i = 0; i < arr.length; i += size) {
        res.push(arr.slice(i, i + size));
      }
      return res;
    },
    onLeftClick(item, index) {
      navigateTo(this, item);
    },
    onRightClick(item) {
      navigateTo(this, item);
    }
  }
};
</script>

<style lang="less" scoped>
@value: calc(50% - 6px);
.compose {
  display: flex;
  justify-content: space-between;
  .div {
    position: relative;
    width: @value;
  }
}
.indicators {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  .indicator {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transition: all 0.3s;
    box-sizing: border-box;
    border: 2px solid #d1d1d1;
    &:last-child {
      margin-right: 0;
    }
  }
  .indicator.active {
    width: 26px;
    border-radius: 8px;
    background: #ffffff;
  }
}
.swiper {
  height: 100%;
}
.image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.style-one {
  .view {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .image-box {
    height: @value;
  }
}
.style-two {
  .div:last-child {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .view {
    height: @value;
    display: flex;
    justify-content: space-between;
  }
  .image-box {
    width: 50%;
  }
}
</style>
